<script>
  export let name;

  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';
  
  let item = [];
  let loading = false;
  let error = false;

  function fetchItems(name) {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getModelsItem', {name: name})
        .then(response => response.json())
        .then(response => item = response.result.items[0])
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  $: fetchItems(name);
</script>

<!-- HTML ----------------------------------------------------------------------->

{#if loading}
<!-- thumbs[TYPE].length === 0 && !galleryError -->
  <div class="lds-css">
    <div class="lds-eclipse"><div></div></div>
  </div>
  
{:else if item}
  <div>
    <div id="containerItem" class="gallery-models-item">
      <i id="typeItem" class="fas fa-2x fa-{Constants.GALLERY_MODELS_TYPES[item.type] || Constants.GALLERY_MODELS_TYPES_DEFAULT} {item.type}"></i>
      <h2 id="titleItem" class="rowItem def_back">
        {item.title_en}
      </h2>
      <div id="bodyItem">
        <img class="rowItem" src="{Constants.PUBLIC_MODELS_IMAGES_3D + item.name + Constants.GALLERY_FILE_EXT}"
            id="imgItem" alt="" height="{item.size}" width="{item.width || item.size}" />
      </div>
    </div>
  </div>

{:else if error}
  <div class="gallery-error">
    <i class="far fa-times-circle"></i>
    {$_('errors.UNKNOWN')}
  </div>
{/if}

<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$type-lighten: 5%;

#containerItem {
  #typeItem {
    color: lighten($idro-palette-first, $type-lighten);
    &.buildings { color: lighten($idro-gallery-buildings, $type-lighten); }
    &.characters { color: lighten($idro-gallery-characters, $type-lighten); }
    &.weapons { color: lighten($idro-gallery-weapons, $type-lighten); }
    &.animals { color: lighten($idro-gallery-animals, $type-lighten); }
    &.objects { color: lighten($idro-gallery-objects, $type-lighten); }
    &.monsters { color: lighten($idro-gallery-monsters, $type-lighten); }
    &.vehicles { color: lighten($idro-gallery-vehicles, $type-lighten); }
  }
  #bodyItem {
    display: inline;
    #imgItem {
      min-height: 300px;
      min-width: 300px;
      background: black;
      @include box-shadow-custom();
    }
    .input-link {
      margin: 0;
      &.prev, &.next {
        width: 92px;
        .input-icon-img {
          display: inline;
          margin: 0;
          float: left;
          border: 1px solid #2b2b2b;
        }
        position: relative;
        .input-icon-arrow {
          position: absolute;
          bottom: 6px;
          right: 6px;
          font-size: 20px;
        }
        .input-icon-text {
          color: grey;
          position: absolute;
          top: 3px;
          right: 6px;
        }
      }
      &.prev { float: left; }
      &.next { float: right; }
    }
  }
}
</style>
